import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { reloadOnChunkLoadError } from '@iupics-manager/managers/app-update/app-update.service';
import { MessageManagerService } from '@iupics-manager/managers/message/message-manager.service';
import { IupicsMessage } from '@iupics-manager/models/iupics-message';

@Injectable()
export class IuErrorHandler implements ErrorHandler {
  constructor(private messageManager: MessageManagerService) {}

  handleError(error: any): void {
    if (reloadOnChunkLoadError(error)) {
      return;
    }
    if (error instanceof HttpErrorResponse) {
      // the request counter is decreased by the interceptor (finalize) only: a second decrease here made
      // Global.isActiveRequest() say idle while requests were still running
      console.error(error);
      this.messageManager.newMessage({
        name: `${error.name} - ${error.status}`,
        message: error.error?.message ?? error.message,
        stack: `${error.message}\n${error.url}`,
      });
    } else if (error instanceof IupicsMessage) {
      if (error.type !== 'success') {
        console.error(error);
      }
      this.messageManager.newMessage(error);
    } else {
      console.error(error);
      this.messageManager.newMessage(error);
    }
  }
}
